import {AxiosCall} from '../axios';

export function serializeQueryParams(obj: any = {}): string {
  const str = [];
  for (const key of Object.keys(obj)) {
    str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
  }
  return str.join('&');
}

export const getPaymentsByClinic = async (
  groupId: number | string,
  clinicId: number | string,
  options: any
): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${groupId}/clinic/${clinicId}/payment/?${serializeQueryParams(
      options
    )}`,
    options.cancelToken
  );
};

export const downloadPaymentsByClinic = async (
  groupId: number | string,
  clinicId: number | string,
  options: any
): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${groupId}/clinic/${clinicId}/payment/download?${serializeQueryParams(
      options
    )}`,
    options
  );
};

export const setPostingStatus = async (
  groupId: number | string,
  clinicId: number | string,
  paymentId: number | string
): Promise<any> => {
  return AxiosCall.put(
    `/clinic-group/${groupId}/clinic/${clinicId}/payment/${paymentId}/post-to-emr`,
    {}
  );
};

export const sendConfirmationMail = async (
  groupId: number | string,
  clinicId: number | string,
  paymentId: number | string,
  payload: {
    email: string;
    thanks_screen?: boolean;
  }
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${groupId}/clinic/${clinicId}/payment/${paymentId}/confirmation-email`,
    payload
  );
};

export const downloadPaymentReceipt = async (
  groupId: number | string,
  clinicId: number | string,
  invoice_number: number | string
): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${groupId}/clinic/${clinicId}/payment/${invoice_number}/download-invoice`
  );
};

export const getPaymentAuditByClinic = async (
  groupId: number | string,
  clinicId: number | string,
  options: any
): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${groupId}/clinic/${clinicId}/payment-audit/?${serializeQueryParams(
      options
    )}`,
    options
  );
};

export const sendRefundEmail = async (
  groupId: number | string,
  clinicId: number | string,
  refundId: number | string,
  body: {
    email: string;
  }
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${groupId}/clinic/${clinicId}/payment/refund/${refundId}/confirm-email`,
    body
  );
};

export const getPaymentsByGuarantor = async (
  groupId: number | string,
  guarantorId: number | string,
  clinicId?: number | string
): Promise<any> => {
  let queryParams = '';
  if (clinicId) {
    queryParams += `clinic_id=${clinicId}`;
  }
  return AxiosCall.get(
    `/clinic-group/${groupId}/guarantor/${guarantorId}/payments?${queryParams}`
  );
};
